import { useSelector } from "react-redux";
import PanelLayout from "../../../layouts/PanelLayout";
import React from "react";
import { Container, Card, Row, Col, Alert } from "react-bootstrap";

function InicioData() {
  const usuario = useSelector((state) => state.usuario);
  const alumno = useSelector((state) => state.alumno);
  const ctacte = useSelector((state) => state.ctacte);

  const obtenerNivelAlumno = (al) =>
    al?.nivel ||
    al?.nivelNombre ||
    al?.nivelDescripcion ||
    al?.nombrenivel ||
    al?.descripcionNivel ||
    al?.curso ||
    al?.grado ||
    al?.sala ||
    "";

  const alumnosConNivel =
    alumno
      ?.map((al) => {
        const nombre = al?.nombre?.trim();
        const nivel = obtenerNivelAlumno(al)?.trim();

        if (!nombre) return null;
        return nivel ? `${nombre} (${nivel})` : nombre;
      })
      .filter(Boolean)
      .join(", ") || "-";

  const hoy = new Date();
  const mesActual = hoy.getMonth() + 1;
  const anioActual = hoy.getFullYear();

  const formatMoney = (n) =>
    new Intl.NumberFormat("es-AR", { minimumFractionDigits: 0 }).format(
      Number(n || 0)
    );

  const calcularMesesDeMora = (mes, anio) => {
    const diferencia =
      (anioActual - Number(anio)) * 12 + (mesActual - Number(mes));
    return Math.max(0, diferencia);
  };

  const calcularTotalConInteresAcumulativo = (item) => {
    const base = Number(item.debe || 0) + Number(item.interes || 0);
    const mesesDeMora = calcularMesesDeMora(item.mes, item.anio);
    return base * Math.pow(1.06, mesesDeMora);
  };

  const cuotas = ctacte?.filter((item) => item.codcomprobante === "C") || [];
  const cuotasImpagas = cuotas.filter((cuota) => {
    const cuotaMes = Number(cuota.mes);
    const cuotaAnio = Number(cuota.anio);
    const total = Number(cuota.debe || 0) + Number(cuota.interes || 0);

    const esMesSiguiente =
      (cuotaAnio === anioActual && cuotaMes === mesActual + 1) ||
      (mesActual === 12 && cuotaAnio === anioActual + 1 && cuotaMes === 1);

    if (cuotaMes === 0 || total === 0 || esMesSiguiente) return false;
    if (cuotaAnio < 2025) return false;

    const estaPagada = ctacte.some(
      (mov) =>
        (mov.codcomprobante === "FC" || mov.codcomprobante === "FE") &&
        Number(mov.idInternoComprobantePagado) ===
          Number(cuota.idInternoComprobante)
    );

    const vencida =
      cuotaAnio < anioActual ||
      (cuotaAnio === anioActual && cuotaMes <= mesActual);

    return !estaPagada && vencida;
  });

  const resumenPorMes = {};
  cuotasImpagas.forEach((it) => {
    const key = `${it.mes}/${it.anio}`;
    const montoConInteres = calcularTotalConInteresAcumulativo(it);

    if (!resumenPorMes[key]) {
      resumenPorMes[key] = 0;
    }

    resumenPorMes[key] += montoConInteres;
  });

  const cuotasAgrupadas = Object.entries(resumenPorMes)
    .map(([mesAnio, total]) => {
      const [mes, anio] = mesAnio.split("/").map(Number);
      return { mes, anio, total };
    })
    .sort((a, b) => a.anio - b.anio || a.mes - b.mes);

  const saldoPendienteTotal = cuotasAgrupadas.reduce(
    (sum, it) => sum + Number(it.total || 0),
    0
  );

  return (
    <PanelLayout>
      <Container className="py-3 py-md-4">
        <div className="inicio-portal-header mb-4">
          <div>
            <p className="inicio-portal-kicker mb-2">Portal de Familias</p>
            <h1 className="inicio-portal-title mb-1">Estado de cuenta</h1>
            <p className="inicio-portal-subtitle mb-0">
              Resumen actualizado de cuotas pendientes por mes.
            </p>
          </div>
        </div>

        <Card className="border-0 shadow-sm inicio-portal-card">
          <Card.Body className="p-3 p-md-4 p-lg-5">
            <Row className="g-3 mb-4">
              <Col md={4}>
                <div className="inicio-portal-info-box h-100">
                  <span className="inicio-portal-label">Familia</span>
                  <strong>{usuario?.familia?.apellido || "-"}</strong>
                </div>
              </Col>

              <Col md={4}>
                <div className="inicio-portal-info-box h-100">
                  <span className="inicio-portal-label">Alumnos</span>
                  <strong>{alumnosConNivel}</strong>
                </div>
              </Col>

              <Col md={4}>
                <div className="inicio-portal-info-box h-100">
                  <span className="inicio-portal-label">Total mensual actual</span>
                  <strong>
                    $
                    {new Intl.NumberFormat("es-AR").format(
                      alumno?.reduce(
                        (s, al) => s + Number(al?.importefinal || 0),
                        0
                      ) || 0
                    )}
                  </strong>
                </div>
              </Col>
            </Row>

            {saldoPendienteTotal <= 0 ? (
              <Alert variant="success" className="mb-0">
                No registra deuda pendiente.
              </Alert>
            ) : (
              <div className="inicio-deuda-panel">
                <div className="inicio-deuda-total">
                  <span>Total adeudado</span>
                  <strong>${formatMoney(saldoPendienteTotal)}</strong>
                </div>

                <div className="inicio-deuda-lista">
                  {cuotasAgrupadas.map((it, idx) => (
                    <div key={idx} className="inicio-deuda-item">
                      <div>
                        <span className="inicio-deuda-mes">
                          {new Date(it.anio, it.mes - 1).toLocaleString("es-AR", {
                            month: "long",
                            year: "numeric",
                          })}
                        </span>
                        <small className="inicio-deuda-caption">
                          Total adeudado del período
                        </small>
                      </div>
                      <strong>${formatMoney(it.total)}</strong>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
    </PanelLayout>
  );
}

export default InicioData;
